<template>
    <div>
        <b-button v-b-modal.trailer variant="primary" class="trailer">Watch trailer</b-button>

        <b-modal size="xl" id="trailer" title="Watch the course trailer" :ok-only="true" ok-variant="link" ok-title="Close">
            <div class="embed-responsive embed-responsive-16by9">
                <lite-youtube class="embed-responsive-item"
                    :videoid="youtubeId"
                    :style="'background-image: url(https://i.ytimg.com/vi/'+ youtubeId +'/maxresdefault.jpg);'"></lite-youtube>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            youtubeId: '',
        },

        data() {
            return {
            }
        },

        mounted() {

        },

        methods: {

        }
    }
</script>
